// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25226
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25226 
import { eventTrackingUtils } from '@/utils/eventTrackingUtils'
export const PageId = Object.freeze({
  Shopcart_Main: 'Shopcart_Main'
})

interface IPVTrackParamsRecord {
  /** 购物车页 */
Shopcart_Main: undefined
}

const sendPv = {
  /** PV-购物车页 */
Shopcart_Main: () => {
    eventTrackingUtils.submitPV({page_id:PageId.Shopcart_Main});
  },
}

interface IExpoTrackParamsRecord {
  /** 凑单包邮提示条曝光 */
Shopcart_FreeShippingPromptStrip_Expo: {
/** 展示文本  */
displayText: string,
/** 是否满足包邮状态  */
freeShipStatus: string}
  /** 商品卡片更多操作小弹窗曝光 */
Shopcart_ProductOperationBtn_Expo: undefined
  /** 列表空状态曝光 */
Shopcart_NullStatus_Expo: {
/** 展示类型  */
showType: string,
/** 是否登录 0-否,1-是 */
is_login: | '0'| '1'}
  /** 引导登录提示条曝光 */
Shopcart_GuideLoginStrip_Expo: undefined
  /** toast提示条曝光 */
Shopcart_ToastPromptStrip_Expo: {
/** 展示文本  */
displayText: string}
  /** 结算按钮曝光 */
Shopcart_CheckoutBtn_Expo: undefined
  /** 加车明细弹层曝光 */
Shopcart_ProductCard_AddCartDetailLayer_Expo: undefined
  /** 0元单提示条曝光 */
Shopcart_ZeroPurchaseOrderStrip_Expo: {
/** 展示文本  */
displayText: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 凑单包邮提示条曝光 */
  Shopcart_FreeShippingPromptStrip_Expo:'Shopcart_FreeShippingPromptStrip_Expo',
/** 商品卡片更多操作小弹窗曝光 */
  Shopcart_ProductOperationBtn_Expo:'Shopcart_ProductOperationBtn_Expo',
/** 列表空状态曝光 */
  Shopcart_NullStatus_Expo:'Shopcart_NullStatus_Expo',
/** 引导登录提示条曝光 */
  Shopcart_GuideLoginStrip_Expo:'Shopcart_GuideLoginStrip_Expo',
/** toast提示条曝光 */
  Shopcart_ToastPromptStrip_Expo:'Shopcart_ToastPromptStrip_Expo',
/** 结算按钮曝光 */
  Shopcart_CheckoutBtn_Expo:'Shopcart_CheckoutBtn_Expo',
/** 加车明细弹层曝光 */
  Shopcart_ProductCard_AddCartDetailLayer_Expo:'Shopcart_ProductCard_AddCartDetailLayer_Expo',
/** 0元单提示条曝光 */
  Shopcart_ZeroPurchaseOrderStrip_Expo:'Shopcart_ZeroPurchaseOrderStrip_Expo',
})

interface IClickTrackParamsRecord {
  /** 凑单包邮提示条点击 */
Shopcart_FreeShippingPromptStrip_Click: {
/** 展示文本  */
displayText: string,
/** 是否满足包邮状态  */
freeShipStatus: string}
  /** 加购商品卡片-空白区-点击（进商详） */
Shopcart_ProductCard_OtherPos_Click: {
/** 商品id  */
skuid: string,
/** 商品状态  */
skuStatus: string,
/** 位置  */
index: number,
/** 加购购买商品数量  */
skuNum: string,
/** 单品促销  */
single_promotion: string,
/** 总价促销  */
amount_promotion: string,
/** 时效标签  */
time_label: string}
  /** 加购商品卡片-规格选择-点击 */
Shopcart_ProductCard_Spec_Click: {
/** 商品id  */
skuid: string,
/** 商品状态  */
skuStatus: string,
/** 位置  */
index: number,
/** 加购购买商品数量  */
skuNum: string,
/** 单品促销  */
single_promotion: string,
/** 总价促销  */
amount_promotion: string,
/** 时效标签  */
time_label: string}
  /** 加购商品卡片-数量编辑框点击 */
Shopcart_ProductNumEditBox_Click: {
/** 商品id  */
skuid: string,
/** 点击位置  */
clickPos: string}
  /** 加购商品卡片操作按钮点击 */
Shopcart_ProductOperationBtn_Click: {
/** 商品id  */
skuid: string,
/** 按钮名称  */
btnName: string}
  /** 列表空状态-按钮点击 */
Shopcart_NullStatusBtn_Click: {
/** 展示类型  */
showType: string,
/** 是否登录 0-否,1-是 */
is_login: | '0'| '1'}
  /** 引导登录提示条点击 */
Shopcart_GuideLoginStrip_Click: undefined
  /** 全选按钮点击 */
Shopcart_SelectAllBtn_Click: {
/** 选中状态  */
selectStatus: string}
  /** 结算按钮点击 */
Shopcart_CheckoutBtn_Click: {skuList: Array<{
/** 商品id  */
skuid: string,
/** 加购购买商品数量  */
skuNum: string}>}
}

const sendClickTrack = {
  /** 点击事件上报-凑单包邮提示条点击 */
Shopcart_FreeShippingPromptStrip_Click: (json_param: IClickTrackParamsRecord['Shopcart_FreeShippingPromptStrip_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_FreeShippingPromptStrip_Click',json_param});
  },
  /** 点击事件上报-加购商品卡片-空白区-点击（进商详） */
Shopcart_ProductCard_OtherPos_Click: (json_param: IClickTrackParamsRecord['Shopcart_ProductCard_OtherPos_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_ProductCard_OtherPos_Click',json_param});
  },
  /** 点击事件上报-加购商品卡片-规格选择-点击 */
Shopcart_ProductCard_Spec_Click: (json_param: IClickTrackParamsRecord['Shopcart_ProductCard_Spec_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_ProductCard_Spec_Click',json_param});
  },
  /** 点击事件上报-加购商品卡片-数量编辑框点击 */
Shopcart_ProductNumEditBox_Click: (json_param: IClickTrackParamsRecord['Shopcart_ProductNumEditBox_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_ProductNumEditBox_Click',json_param});
  },
  /** 点击事件上报-加购商品卡片操作按钮点击 */
Shopcart_ProductOperationBtn_Click: (json_param: IClickTrackParamsRecord['Shopcart_ProductOperationBtn_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_ProductOperationBtn_Click',json_param});
  },
  /** 点击事件上报-列表空状态-按钮点击 */
Shopcart_NullStatusBtn_Click: (json_param: IClickTrackParamsRecord['Shopcart_NullStatusBtn_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_NullStatusBtn_Click',json_param});
  },
  /** 点击事件上报-引导登录提示条点击 */
Shopcart_GuideLoginStrip_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_GuideLoginStrip_Click'});
  },
  /** 点击事件上报-全选按钮点击 */
Shopcart_SelectAllBtn_Click: (json_param: IClickTrackParamsRecord['Shopcart_SelectAllBtn_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_SelectAllBtn_Click',json_param});
  },
  /** 点击事件上报-结算按钮点击 */
Shopcart_CheckoutBtn_Click: (json_param: IClickTrackParamsRecord['Shopcart_CheckoutBtn_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Shopcart_CheckoutBtn_Click',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}